import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WorkforceService } from 'src/app/services/workforce.service';
import { EventService } from 'src/app/services/event.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'edit-role-dialog',
    template: `
  <div class="edit-role-dialog joi-dialog">
      <div mat-dialog-title>Edit Role</div>
      <div mat-dialog-content>
          <div class="label">Edit role for {{data.worker.firstName + ' ' + data.worker.lastName}}</div>
          <mat-form-field class="general">
              <input matInput name="role" [(ngModel)]="role" placeholder="Role">
          </mat-form-field>
      </div>
      <div mat-dialog-actions>
          <div style="flex:1;"></div>
          <button mat-button (click)="dialogRef.close()">CANCEL</button>
          <button mat-button color="primary" (click)="saveRole()" tabindex="1">Save</button>
      </div>
  </div>
  `,
    styleUrls: [`./workforce.main.scss`],
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, FormsModule, CommonModule]
})
export class EditRoleDialogComponent {

  role = '';
  constructor(public dialogRef: MatDialogRef<EditRoleDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
      private workforce: WorkforceService, public event: EventService) {
      this.role = data.worker.role;
  }
  saveRole() {
      this.data.worker.role = this.role;
      // this.workforce.saveRole();
      this.dialogRef.close('save');
  }
}

